import { render, staticRenderFns } from "./form-forget-password.vue?vue&type=template&id=52d05572&"
import script from "./form-forget-password.vue?vue&type=script&lang=ts&"
export * from "./form-forget-password.vue?vue&type=script&lang=ts&"
import style0 from "./form-forget-password.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports